import { media } from 'src/common/styles/breakpoints';
import styled, { css } from 'styled-components';

const AspspControlWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 0.5rem;
  ${media.w.min.px576(css`
    margin-top: 2rem;
  `)}
`;

export default AspspControlWrapper;
